import typing from './typing';


class list {

    static removeOne(array, predicate) {
        for (let i = 0; i < array.length; i++) {
            if (predicate(array[i])) {
                return array.splice(i, 1);
            }
        }
        return undefined;
    }

    static removeOneReturnArray(array, element) {
        for (let i = 0; i < array.length; i++) {
            if (typing.areEqual(array[i], element)) {
                array.splice(i, 1);
                break;
            }
        }
        return array;
    }

    static removeDuplicatesByObject(array, prop) {
        return array.filter((obj, pos, arr) => {
            return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
        });
    }

    static filterOne(array, predicate) {
        for (let i = 0; i < array.length; i++) {
            if (predicate(array[i])) {
                return array[i];
            }
        }
        return undefined;
    }

    static filter(array, predicate) {
        const returnArray = [];
        for (let i = 0; i < array.length; i++) {
            if (predicate(array[i])) {
                returnArray.push(array[i]);
            }
        }
        return returnArray;
    }

    static remove(array, predicate) {
        const removed = [];
        for (let i = 0; i < array.length;) {
            if (predicate(array[i])) {
                removed.push(array.splice(i, 1));
                continue;
            }
            i++;
        }
        return removed;
    }

    static contains(array, predicate) {
        for (let i = 0; i < array.length;) {
            if (predicate(array[i])) {
                return true;
            }
            i++;
        }
        return false;
    }

    static getIndex(array, predicate) {
        for (let i = 0; i < array.length;) {
            if (predicate(array[i])) {
                return i;
            }
            i++;
        }
        return -1;
    }

    static getDistinct(array, field) {
        return [...new Set(array.map(item => item[field]))];
    }

    static getMax(array, field) {
        return Math.max.apply(Math, array.map(item => item[field]));
    }

    static getMin(array, field) {
        return Math.min.apply(Math, array.map(item => item[field]));
    }

    static getSum(array, field) {
        let sum = 0;
        for (let i = 0; i < array.length; i++) {
            sum += array[i][field];
        }
        return sum;
    }

    static replaceItem(array, item, predicate) {
        let indexToFind = -1;
        for (let i = 0; i < array.length; i++) {
            if (predicate(array[i], item)) {
                indexToFind = i;
                break;
            }
        }

        if (indexToFind >= 0) {
            array[indexToFind] = item;
        }

    }

    static convertToIntArray(commaSeparatedString) {
        if (commaSeparatedString && commaSeparatedString.split) {
            return commaSeparatedString.split(",").map(Number);
        }
        else {
            return [];
        }
    }

    static sortBySummation(array) {
        array.sort(function (a, b) {
            if (a.Summation < b.Summation) {
                return 1;
            }
            else if (a.Summation > b.Summation) {
                return -1;
            }
            else {
                return 0;
            }
        });
    }



}

export default list;
